import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import FailedPaymentModal from "./modals/FailedPaymentModal";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";

export default function FailedPayments() {
  const [failedPayments, setFailedPayments] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [failedPaymentModal, setFailedPaymentModal] = useState(false);
  const [failedpaymentId, setFailedpaymentId] = useState(0);
  const { user,dispatch } = useAuthContext();
const navi = useNavigate();




  const cancelModal = (e) => {
    setFailedPaymentModal(false);
  };

  const OpenFailedPayModel = (e) => {
    cancelModal();
    setFailedpaymentId(e);
    setFailedPaymentModal(true);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const failedPaymentsResponse = await axios.get(
        `${ApiConnectionString}/api/FailedPayments`,
        {
          headers: { Authorization: `Bearer ${user?.token}` },
        }
      );
      setFailedPayments(failedPaymentsResponse.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error(
        "Error fetching failed payments:",
        error.response?.data || error.message
      );
    } finally {
      setIsLoading(false);
    }
  };

  //Get the Users Data
  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }
  }, [user]);
  if (isLoading) {
    return <LoadingSpinner />;
  } else {
    return (
      <div>
        {" "}
        <div className="lightBlueBanner text-center">
          <p className="fw-bold mx-3 p-1 mt-2">Failed Payments</p>
        </div>
        {failedPayments.length > 0 ? (
          <table className="custom-table">
            <thead className="blueBanner">
              <tr>
                <th>Date</th>
               
                <th>Club</th>
                <th>Package</th>

                <th className="hideAt450">Scope</th>
              </tr>
            </thead>
            <tbody>
              {failedPayments.map((fail) => (
                <tr
                  key={fail.id}
                  onClick={() => {
                    setFailedpaymentId(fail.id);
                    setFailedPaymentModal(true);
                  }}
                >
                  {fail.created && <td>{fail.created.substring(0, 10)}</td>}
                  <td>{fail.viewClubs.name}</td>
                  {!fail.preimum ? (
                    <td>{fail.viewProduct.name}</td>
                  ) : (
                    <td>Membotic Premium</td>
                  )}
                  {fail.periodStart && (
                    <td className="hideAt450">
                      {fail.periodStart.substring(0, 10)} -{" "}
                      {fail.periodEnd.substring(0, 10)}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-muted">No Failed Payments</p>
        )}
        {failedPaymentModal && failedpaymentId != 0 && (
          <FailedPaymentModal
            cancelModal={cancelModal}
            id={failedpaymentId}

          />
        )}
      </div>
    );
  }
}
